import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewChild,
  ElementRef,
  input,
  HostListener,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { Store } from '@ngrx/store';
import { TextareaModule } from 'primeng/textarea';

import { PostMessageTemplateRequest } from '@offconon/core-api';
import { MaterialIconComponent } from '@offconon/shared/ui/material-icon';
import { WebSocketService } from '@offconon/shared/utils/services/websocket';

@Component({
  selector: 'offconon-chat-message-input',
  imports: [CommonModule, MaterialIconComponent, TextareaModule, PickerModule],
  templateUrl: './chat-message-input.component.html',
  styleUrls: ['./chat-message-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageInputComponent {
  @ViewChild('messageInput') messageInput!: ElementRef<HTMLTextAreaElement>;
  roomId = input.required<number>();
  webSocketService = inject(WebSocketService);
  private store = inject(Store);
  iconsVisible = false;
  private fb = inject(FormBuilder);
  emojiVisible = false;

  toggleIcons() {
    this.iconsVisible = !this.iconsVisible;
  }

  sendMessage(message: string) {
    if (!this.roomId()) return;
    this.webSocketService.send({
      message,
      room_id: this.roomId(),
      communication_type: PostMessageTemplateRequest.CommunicationTypeEnum.Chat,
    });
    this.messageInput.nativeElement.value = '';
    this.messageInput.nativeElement.style.height = 'auto';
  }

  sendLike(messageInput: HTMLTextAreaElement) {
    const likeEmoji = '👍';
    const cursorPos = messageInput.selectionStart;
    const textBefore = messageInput.value.substring(0, cursorPos);
    const textAfter = messageInput.value.substring(cursorPos);

    messageInput.value = textBefore + likeEmoji + textAfter;
    messageInput.selectionStart = messageInput.selectionEnd = cursorPos + likeEmoji.length;
    messageInput.focus();
    this.sendMessage(messageInput.value);
  }
  sendEmoji(event: any, messageInput: HTMLTextAreaElement) {
    const emoji = event.emoji.native;
    const cursorPos = messageInput.selectionStart;
    const textBefore = messageInput.value.substring(0, cursorPos);
    const textAfter = messageInput.value.substring(cursorPos);
    messageInput.value = textBefore + emoji + textAfter;

    const newCursorPos = cursorPos + emoji.length;
    messageInput.selectionStart = messageInput.selectionEnd = newCursorPos;

    messageInput.focus();

    const inputEvent = new Event('input', { bubbles: true });
    messageInput.dispatchEvent(inputEvent);
  }
  sendVoiceMessage() {}
  sendImage() {}
  sendGif() {}

  toggleEmojiMart() {
    this.emojiVisible = !this.emojiVisible;
  }
  @HostListener('document:click', ['$event'])
  closeEmojiMart(event: MouseEvent) {
    const emojiMart = document.querySelector('.emoji-on');
    const clickedInside = emojiMart?.contains(event.target as Node);
    if (!clickedInside) {
      this.emojiVisible = false;
    }
  }
}
